import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
import { Spin } from 'antd';
import { observer } from 'mobx-react-lite';

import authStore from '@/stores/auth';
import { fetchH5ResignationConfig } from './services';

const ResignationFeatureRoute = ({ component }) => {
  useEffect(() => {
    if (authStore.features.h5ResignationLoaded) return;

    fetchH5ResignationConfig()
      .then((response) => {
        authStore.setFeatures({
          h5ResignationEnabled: response?.code === 0 && response?.data?.enabled === true,
          h5ResignationLoaded: true,
        });
      })
      .catch(() => {
        authStore.setFeatures({
          h5ResignationEnabled: false,
          h5ResignationLoaded: true,
        });
      });
  }, []);

  if (!authStore.features.h5ResignationLoaded) {
    return <Spin spinning />;
  }

  if (!authStore.features.h5ResignationEnabled) {
    return <Navigate to="/" replace />;
  }

  return component;
};

ResignationFeatureRoute.propTypes = {
  component: PropTypes.node.isRequired,
};

export default observer(ResignationFeatureRoute);
